import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { select } from '@ngxs/store';
import { CustomIconService } from './core/services/icon.service';
import { Theme } from './support/models/theme.model';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ThemeService } from './core/services/theme.service';
import { FloatingFeedbackButtonComponent } from './core/components/floating-feedback-button/floating-feedback-button.component';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { MainMenuComponent } from './core/components/main-menu/main-menu.component';
import { EmergencyAlertComponent } from './core/components/emergency-alert/emergency-alert.component';
import { SaleSelectors } from './sales/states/sale/sale.selectors';
import { DevToolsService } from './dev-tools/dev-tools.service';
import { VerificationUrlListenerService } from '@app/core/services/verification-url-listener.service';
import { TrackingService } from '@app/core/services/tracking.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [EmergencyAlertComponent, MainMenuComponent, RouterOutlet, FloatingFeedbackButtonComponent, AsyncPipe],
})
export class AppComponent implements OnInit {
  iconService = inject(CustomIconService);
  private overlayContainer = inject(OverlayContainer);
  private themeService = inject(ThemeService);
  // Injected so its constructor runs and registers the command palette's keydown listener.
  private devToolsService = inject(DevToolsService);
  // Injected so its constructor runs and starts Application Insights page-view and context tracking.
  private trackingService = inject(TrackingService);
  verificationUrlListenerService = inject(VerificationUrlListenerService);

  emergencyAlerts = select(SaleSelectors.getEmergencyAlerts);

  selectedTheme$: Observable<string>;

  constructor() {
    this.iconService.registerIcons();
  }

  ngOnInit() {
    this.selectedTheme$ = this.themeService.selectedTheme.pipe(
      tap((selectedTheme: Theme) => this.initTheme(selectedTheme)),
      map((selectedTheme: Theme) => selectedTheme.name)
    );
  }

  private initTheme(selectedTheme: Theme) {
    const classList = this.overlayContainer.getContainerElement().classList;
    const toRemove = Array.from(classList).filter((item: string) => item.includes('-theme'));

    if (toRemove.length) {
      classList.remove(...toRemove);
    }
    classList.add(selectedTheme.name);
  }
}
